import React from 'react';
import { History } from 'history';
import BaseCreate from '../base/base-create.component'; 
import Model from './user-model';  //editable..

interface IProps { 
    history: History;
    successCaption?: string;
    useremail?: string;
    save?: boolean;
    onSave?: (data: any) => void;
    onError?: (data: any) => void;
}

interface IState {
    datarow: Model;
    errors: any;
    save: boolean;
}

export default class UserAuthGetToken extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onError = (data: any) => {
        this.props.onError?.(data)
        this.setState({errors: data});
    }

    private onSave = (data: any) => {
        this.setState({save: false});
        this.props.onSave?.(data)
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }
    public componentDidMount(){
        this.setState({datarow: Model.defaultValueGetToken as any})
    }

    public componentDidUpdate = () => {
        if (this.props.save && this.props.save !== this.state.save && this.props.useremail)
            this.setState({ datarow: { ...this.state.datarow, 'useremail': this.props.useremail, 'email': Model.getEmailApp(this.props.useremail)}, save: true });
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} caption=' ' buttonCaption=' ' successCaption={this.props.successCaption || 'Token created.'}
                endPoint={Model.endPointAuth+ '/get-token'} model={Model} datarow={this.state.datarow} onError={this.onError} save={this.state.save} onSave={this.onSave} disableAutoBack disableBackButton/>
        );
    }     
     
}